import React, { useMemo } from 'react';
import { map } from 'lodash';
import SelectBoxField from '../../../../common/components/containers/EntityForm/fields/SelectBoxField';
import useLabel from '../../../../common/components/utils/Translations/useLabel';
import useWeekdays from '../../../../common/data/useWeekdays';
const WeekDayField = ({ label, name = 'weekStartsFrom', required, dataCy, }) => {
    const _label = useLabel('Week Starts From', label);
    const { weekdays, loading, error } = useWeekdays();
    const _options = useMemo(() => map(weekdays, ({ id, name }) => ({ value: id, name, id })), [weekdays]);
    return (<SelectBoxField dataCy={dataCy} error={error} label={_label} loading={loading} name={name} options={_options} orderOptionsBy="id" required={required}/>);
};
export default WeekDayField;
